let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7g4XQ")).then(() => parcelRequire('64wtY'));